import React from 'react';
import {observer} from 'mobx-react';
import {EPLines} from './ep-lines';
import {EPMethod, PCS_CSS, ProductCustomizationState} from '../../../rendering/render.def';

type Props = {
    css: PCS_CSS;
    pcs: ProductCustomizationState;
};

export const EPContent: React.FC<Props> = observer(({pcs, css}: Props) => {
    const isEPCustom = pcs.EPMethodID === EPMethod.Custom;
    const isEPSingleDoc = pcs.EPMethodID === EPMethod.SingleDoc;
    const showEditor = isEPCustom || isEPSingleDoc;

    const epStyle: React.CSSProperties = {
        backgroundImage: css.ep_backgroundImage,
        backgroundSize: css.ep_backgroundSize,
        color: showEditor ? undefined : css.ep_color,
        left: css.ep_left,
        top: css.ep_top,
        width: css.ep_width,
        height: css.ep_height,
        textAlign: showEditor ? 'initial' : 'center',
        wordBreak: showEditor ? 'break-word' : undefined,
    };

    return (
        <div
            id="ep"
            style={epStyle}
        >
            {showEditor ? (
                <div
                    className="w-100"
                    dangerouslySetInnerHTML={{__html: pcs.RichText}}
                ></div>
            ) : (
                <EPLines
                    pcs={pcs}
                    css={css}
                />
            )}
        </div>
    );
});
